import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import http from './utils/http.util';
import moment from 'moment';
import { BootstrapVue } from 'bootstrap-vue';

import './assets/styles/custom.scss';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

Vue.prototype.$log = console.log;
Vue.prototype.$http = http;
Vue.prototype.$moment = moment;

// Create Vue app
(async () => {
  try {
    // Try to auto login
    const res = await http.post('/auth/refresh-token', { userId: store.state.userId }, { timeout: 3000 /* 3 seconds*/ });
    const { accessToken, user } = res.data;
    store.commit('authUser', { accessToken, userId: user.id });
    store.commit('storeUser', { user, roles: user.roles });
  } catch (error) {
    // Discard any existing session data
    store.commit('discardSession');
  }

  // Start app
  new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app');
})();
